import React from 'react'
import { connect } from 'react-redux'
import Notifications from '../../Notifications'
import { formattedPhone, displayField } from '../../../utils/utils'
import { activeAdminLink } from '../../../helpers/navigationHelpers'
import { toCurrencyString } from '../../../helpers/numberHelpers'
import TooltipGridRow from './TooltipGridRow'
import {Grid, Header, Loader} from 'semantic-ui-react'

class CustomerTooltip extends React.Component {
  componentDidMount() {
    if (!this.props.customer) {
      this.props.dispatch({
        type: 'CUSTOMERS_LOAD_SAGA',
        payload: {customerIds: [this.props.customerId], skipLoading: true}
      })
    }
  }

  displayMembership = (membership) => {
    if (membership == null) return ''
    const { price, plan_name } = membership

    return `${plan_name} - ${toCurrencyString(price)}`
  }

  membershipInfo = (customer, membership) => {
    if ([{}, undefined, null].includes(membership)) return null

    if (membership.price > 0) {
      return (
        <React.Fragment>
          {`${this.displayMembership(membership)}`}
          <span style={{paddingLeft: '10px'}} onClick={() => this.cancelMembership(customer)}>
            <small style={{padding: '4px 6px', color: 'red', border: '1px solid red', borderRadius: '50px', cursor: 'pointer'}}>
              Cancel Membership
            </small>
          </span>
        </React.Fragment>
      )
    }
    else {
      return membership.plan_name
    }
  }

  cancelMembership = (customer) => {
    const membership = customer.active_membership || {}
    const { plan_name, price } = membership

    const resp = window.confirm(
      `Are you sure you want to cancel the ${toCurrencyString(price)} ${plan_name} Membership of customer email ${customer.email}?`
    )

    if (resp === true) {
      this.props.dispatch({
        type: 'MEMBERSHIPS_UPDATE_SAGA',
        payload: { customerId: customer.id, membershipPlanId: customer.free_membership_plan_id },
        callback: (status, data) => {
          if (status === 'success') {
            this.props.dispatch(Notifications.success({
              message: `Success! Customer now has a ${this.displayMembership(data.activeMembership)} membership.`
            }))
          }
          if (status === 'failure') {
            this.props.dispatch(Notifications.error({
              message: `Error updating: ${data.alertMessage}`
            }))
          }
        }
      })
    }
  }

  render() {
    const {isLoading, affiliations, customer} = this.props

    if (isLoading || !customer) {
      return (
          <div className="p-20">
            <Loader active={isLoading} />
          </div>
      )
    }
    const {
      id, full_name, cellPhone, email, impersonation_url, active_membership, affiliation_id
    } = customer
    const affiliation = affiliations.find(a => a.id === affiliation_id)
    const parentAffiliation = affiliation && affiliations.find(a => a.id === affiliation.parent_id)

    const data = [
      {label: 'Name:', attr: full_name},
      {label: 'Cell:', attr: formattedPhone(cellPhone)},
      {label: 'Email:', attr: email},
      {label: 'Affiliation:', attr: affiliation.name},
      {
        label: 'Parent Affiliation:',
        attr: displayField(parentAffiliation && parentAffiliation.name)
      },
      {
        label: 'Membership:',
        attr: this.membershipInfo(customer, active_membership)
      },
    ]

    return (
        <div className="customer-tooltip">
          <Header size='medium' className="mb-10">
            Customer
            <a href={activeAdminLink(`customers/${id}`)} rel='noopener noreferrer' target="_blank">
              <small className="pl-5">(view)</small>
            </a>
            {impersonation_url &&
                <span>
              <small className="pl-5">|</small>
              <a href={impersonation_url} rel='noopener noreferrer' target="_blank">
                <small className="pl-5">(impersonate)</small>
              </a>
            </span>
            }
          </Header>

          <Grid className="grid">
            <TooltipGridRow data={data} labelWidth={5} attrWidth={11}/>
          </Grid>
        </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  let {customer} = props
  if (customer && Object.keys(customer).length === 0) {
    customer = null;
  }
  return {
    affiliations: state.affiliations.affiliations,
    customer: customer,
    isLoading: state.application.isTooltipLoading
  }
}

export default connect(mapStateToProps)(CustomerTooltip)
